import constants from "../common/restService/constant";
import GatewayGet from "../common/restService/GatewayGet";
import dayjs from "dayjs";

let props = {};
let inputObj = {};
props["query"] = constants.serviceRoot;
props["headers"] = constants.serviceHeaders;

let weightThreshold = 0;

export const createQuotation = async (data) => {
  inputObj["Activity"] = "Q_CREATE_QUOTATION";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const saveQuotation = async (data) => {
  inputObj["Activity"] = "INVOICE_QUOTE_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const deleteQuotation = async (data) => {
  inputObj["Activity"] = "INVOICE_QUOTE_DB_OPS";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const foCancel = async (data) => {
  inputObj["Activity"] = "FO_CANCEL";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const validateInvoiceInputs = async (data) => {
  data.im_hawbnumber = String(data.im_hawbnumber).replace(/\t/g, '')
  data.im_prolinenumber = String(data.im_prolinenumber).replace(/\t/g, '')
  data.im_hawbnumber = String(data.im_hawbnumber).replace(/\s/g, '')
  data.im_prolinenumber = String(data.im_prolinenumber).replace(/\s/g, '')
  inputObj["Activity"] = "FO_VALIDATE_HAWB_PRO";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const submitInvoiceInputsService = async (data, Tor_Type) => {
  data.IM_HAWBNUMBER = String(data.IM_HAWBNUMBER).replace(/\t/g, '')
  data.IM_INVOICENUMBER = String(data.IM_INVOICENUMBER).replace(/\t/g, '')
  data.IM_HAWBNUMBER = String(data.IM_HAWBNUMBER).replace(/\s/g, '')
  data.IM_INVOICENUMBER = String(data.IM_INVOICENUMBER).replace(/\s/g, '')
  if (Tor_Type == "ZEXC")
    inputObj["Activity"] = "FO_UPDATE_INVOICE_SCAC_HAWB_SHIPMENTDATE_ZEXC";
  else inputObj["Activity"] = "FO_UPDATE_INVOICE_SCAC_HAWB_SHIPMENTDATE";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const submitChargesService = async (data) => {
  inputObj["Activity"] = "FO_UPDATE_INV_CHARGES";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const foInvoiceSubmitService = async (data) => {
  inputObj["Activity"] = "FO_INVOICE_SUBMIT";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const getWeightThreshold = async () => {
  var obj = {};
  obj["OBJNAME"] = "YTMS_NCRM";
  obj["IDENTIFIER"] = "WEIGHT_THRESHOLD";
  inputObj["Activity"] = "FO_GET_WEIGHT_THRESHOLD";
  inputObj["Input"] = JSON.stringify(obj);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export async function getThresholdValue() {
  var weightValue = 0;
  const threshold = await getWeightThreshold();
  if (threshold.STATUS == "SUCCESS") {
    weightValue = threshold.DOCNUM;
  }
  return weightValue;
}

export const percentageChecker = async (oldValue, newValue, threshold) => {
  if (typeof oldValue !== "undefined" && oldValue !== null && oldValue !== "") {
    oldValue = +oldValue;
    oldValue = parseFloat(parseFloat(oldValue).toFixed(2));
    if (
      typeof newValue !== "undefined" &&
      newValue !== null &&
      newValue !== ""
    ) {
      newValue = +newValue;
      newValue = parseFloat(parseFloat(newValue).toFixed(2));

      var difference = 0;
      difference = newValue - oldValue;
      difference = parseFloat(parseFloat(difference).toFixed(2));

      var percentage = 0;
      percentage = (difference / oldValue) * 100;

      percentage = parseFloat(parseFloat(percentage).toFixed(2));
      //Need to get the threshould value from backend table and use that.
      //  if (percentage > 10) {
      if (percentage > parseInt(threshold)) {
        return false;
      } else {
        return true;
      }
    } else {
      // angular.element("#notification").getKendoNotification().show("New Quantity changed is invalid" + vm.weightThreshold, "error");
      return false;
    }
  } else {
    // angular.element("#notification").getKendoNotification().show("Old Quantity Value is invalid" + vm.weightThreshold, "error");
    return false;
  }
};

export const getQuotation = async (data) => {
  inputObj["Activity"] = "INVOICE_QUOTE_SEARCH";
  inputObj["Input"] = JSON.stringify(data);
  props.input = inputObj;

  const result = await GatewayGet(props, props.input);
  return result;
};

export const setPassThroughFeeCodeForInvoice = (
  currentComponent,
  TransportationValue,
  response2,
  tor_Type
) => {
  if (currentComponent === "invoice") {
    const feeCodePassThrough = [];

    for (let i = 0; i < response2.length; i++) {
      response2[i].text =
        response2[i].feeCode + " (" + response2[i].description + ")";

      if (tor_Type === "ZSSB") {
        // Only for ISR flow inovice component
        if (TransportationValue.value === "S") {
          if (response2[i].basisModeS === "PASS THROUGH") {
            feeCodePassThrough.push(response2[i]);
          }
        }
        if (TransportationValue.value === "A") {
          if (response2[i].basisModeA === "PASS THROUGH") {
            feeCodePassThrough.push(response2[i]);
          }
        }
        if (TransportationValue.value === "R") {
          if (response2[i].basisModeR === "PASS THROUGH") {
            feeCodePassThrough.push(response2[i]);
          }
        }
        if (TransportationValue.value === "M") {
          if (response2[i].basisModeM === "PASS THROUGH") {
            feeCodePassThrough.push(response2[i]);
          }
        }
      } else {
        feeCodePassThrough.push(response2[i]);
      }
    }

    return feeCodePassThrough;
  }
};

export const filterCurrencyWithVendorId = (response, vendor_id) => {
  // Filtering Currency list with vendor id
  let _currencyList = response.filter((list) => vendor_id === list["vendId"]);

  // Filtering the duplicates with currency code
  _currencyList = _currencyList.filter(
    (list, index, arr) =>
      index === arr.findIndex((l) => l.currCode === list.currCode)
  );

  return _currencyList;
};

export const getDefaultCurrencyAsUSD = (
  response,
  vendor_id,
  stauts,
  currency
) => {
  if (stauts === 35) {
    return response.find((curr) => curr["currCode"] === currency);
  }

  const _currencyList = filterCurrencyWithVendorId(response, vendor_id);

  return typeof _currencyList.find((item) => item["currCode"] === "USD") ===
    "undefined"
    ? { currCode: "Select Currency" }
    : _currencyList.find((item) => item["currCode"] === "USD");
};

// export async function getAllQuotation(
//   status,
//   currentComponent,
//   tor_id,
//   tor_Type,
//   rfq_no = "",
//   quotationNum = ""
// ) {
//   if (status.current === null) {
//     return;
//   }
//   let quotationPayload = [];

//   if (status.current === 70 || currentComponent === "bid") {
//     if (tor_Type === "ZMSB") {
//       // Multi bid flow
//     // Multi bid flow
//       // from tendering screen
//       if (rfq_no === '') {
//         quotationPayload = [
//           {
//             orderType: "ZEXC",
//             foNum: tor_id,
//             rfqNum: rfq_no,
//             quotationNum: quotationNum,
//             docType: "INVOICE",
//           },
//         ];
//       } else {
//         // from RFQ
//         quotationPayload = [
//           {
//             orderType: tor_Type,
//             foNum: tor_id,
//             rfqNum: rfq_no,
//             quotationNum: quotationNum,
//             docType: "QUOTE",
//           },
//         ];
//       }
//     } else {
//       quotationPayload = [
//         {
//           orderType: tor_Type,
//           foNum: tor_id,
//           rfqNum: "",
//           quotationNum: "",
//           docType: "QUOTE",
//         },
//       ];
//     }
//   } else {
//     if (tor_Type === "ZMSB") {
//       // Multi bid flow
//       quotationPayload = [
//         {
//           orderType: tor_Type,
//           foNum: tor_id,
//           rfqNum: rfq_no,
//           quotationNum: quotationNum,
//           docType: "INVOICE",
//         },
//       ];
//     } else {
//       quotationPayload = [
//         {
//           orderType: tor_Type,
//           foNum: tor_id,
//           rfqNum: "",
//           quotationNum: "",
//           docType: "INVOICE",
//         },
//       ];
//     }
//   }
//   const response4 = await getQuotation(quotationPayload);
//   return response4;
// }


export async function getAllQuotation(
  status,
  currentComponent,
  tor_id,
  tor_Type,
  rfq_no = "",
  quotationNum = ""
) {
  if (status.current === null) {
    return;
  }
  let quotationPayload = [];

  if (status.current === 70 || currentComponent === "bid") {
    if (tor_Type === "ZMSB") {
      // Multi bid flow
    // Multi bid flow
      // from tendering screen
      if (rfq_no === '') {
        quotationPayload = [
          {
            orderType: "ZEXC",
            foNum: tor_id,
            rfqNum: rfq_no,
            quotationNum: quotationNum,
            docType: "INVOICE",
          },
        ];
      } else {
        // from RFQ
        quotationPayload = [
          {
            orderType: tor_Type,
            foNum: tor_id,
            rfqNum: rfq_no,
            quotationNum: quotationNum,
            docType: "QUOTE",
          },
        ];
      }
    } else {
      quotationPayload = [
        {
          orderType: tor_Type,
          foNum: tor_id,
          rfqNum: "",
          quotationNum: "",
          docType: "QUOTE",
        },
      ];
    }
  } else {
    if (tor_Type === "ZMSB") {
      if (rfq_no === '') {
        quotationPayload = [
          {
             orderType: "ZEXC",
            // orderType : tor_Type,
            foNum: tor_id,
            rfqNum: rfq_no,
            quotationNum: quotationNum,
            docType: "INVOICE",
          },
        ];
      } else {
      // Multi bid flow
      quotationPayload = [
        {
          orderType: tor_Type,
          foNum: tor_id,
          rfqNum: rfq_no,
          quotationNum: quotationNum,
          docType: "INVOICE",
        },
      ];
    }
   } else {
      quotationPayload = [
        {
          orderType: tor_Type,
          foNum: tor_id,
          rfqNum: "",
          quotationNum: "",
          docType: "INVOICE",
        },
      ];
    }
  }
  const response4 = await getQuotation(quotationPayload);
  return response4;
}


// API Calling function Start
export const helperFunc = (activity, input) => {
  let _props = {};
  let inputObj = {};
  _props["query"] = constants.serviceRoot;
  _props["headers"] = constants.serviceHeaders;
  inputObj["Activity"] = activity;
  inputObj["Input"] = input === "" ? "" : JSON.stringify(input);
  _props.input = inputObj;
  return _props;
};
// API Calling function End

export function calculateTotalCharges(arrayInput) {
  var totalContractedCharges = 0;
  var totalNonContractedCharges = 0;
  var totalQuotationCharges = 0;

  for (var i = 0; i < arrayInput.length; i++) {
    if (
      arrayInput[i].chargePerUnit != null &&
      typeof arrayInput[i].chargePerUnit !== "undefined" &&
      arrayInput[i].chargePerUnit !== "" &&
      arrayInput[i].quantity != null &&
      typeof arrayInput[i].quantity !== "undefined" &&
      arrayInput[i].quantity !== ""
    ) {
      arrayInput[i].totalPrice =
        arrayInput[i].chargePerUnit *
        arrayInput[i].quantity;

      if (
        arrayInput[i].contractedYN != null &&
        typeof arrayInput[i].contractedYN !== "undefined" &&
        arrayInput[i].contractedYN !== ""
      ) {
        if (arrayInput[i].contractedYN === "Y") {
          totalContractedCharges += arrayInput[i].totalPrice;
        }
        if (arrayInput[i].contractedYN === "N") { 
          totalNonContractedCharges += arrayInput[i].totalPrice;
        }
      }
    }
  }

  totalContractedCharges =  parseFloat(totalContractedCharges.toFixed(2));
  totalNonContractedCharges =  parseFloat(totalNonContractedCharges.toFixed(2));
  totalQuotationCharges =totalContractedCharges +totalNonContractedCharges;
  totalQuotationCharges=parseFloat(totalQuotationCharges.toFixed(2));

  return {
    totalContractedCharges,
    totalNonContractedCharges,
    totalQuotationCharges,
  };
}

export async function submitInvoiceInputs(
  invoiceBidInputs,
  childScacSelected,
  tor_id,
  Tor_Type
) {
  const validationPayload1 = {
    tor_id,

    IM_HAWBNUMBER: invoiceBidInputs["hawbNumber"],
    IM_PROLINENUMBER: "",
    IM_TSPEXEC_SCAC: childScacSelected["childScac"],
    IM_INVOICENUMBER: invoiceBidInputs["proNumber"],
    // IM_ARRIVALDATE: dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
    //   "DD/MM/YYYY HH:mm:ss"
    // ),
    // IM_DEPARTUREDATE: dayjs(
    //   invoiceBidInputs["actualShipmentDeliveryDate"]
    // ).format("DD/MM/YYYY HH:mm:ss"),

    IM_ARRIVALDATE: dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
      "MM/DD/YYYY HH:mm:ss"
    ),
    IM_DEPARTUREDATE: dayjs(
      invoiceBidInputs["actualShipmentPickupDate"]
    ).format("MM/DD/YYYY HH:mm:ss"),
  };

  

  let response1 = await submitInvoiceInputsService(
    validationPayload1,
    Tor_Type
  );
  return response1;
}

export async function submitChargesMethod(
  tor_id,
  currencySelected,
  totalChargesInvoice
) {
  const validationPayload1 = {
    FoNumber: tor_id,
    ChargeType: "INV",
    ChargeCurrency: currencySelected["currCode"],
    ChargeAmount: totalChargesInvoice["totalQuotationCharges"],
  };

  let response1 = await submitChargesService(validationPayload1);
  return response1;
}

export async function foSubmitInvoiceMethod(tor_id) {
  const validationPayload1 = {
    TOR_ID: tor_id,
  };
  let response1 = await foInvoiceSubmitService(validationPayload1);
  return response1;
}

export function validateInvoiceFieldInputs(
  invoiceBidInputs,
  childScacSelected
) {
  const error = {
    message: "",
    isError: false,
  };

  if (invoiceBidInputs["hawbNumber"] === "") {
    error.message = "HAWB Number is Mandatory";
    error.isError = true;
    return error;
  } else {
    // Validation For Invalid HAWB Number Starts
    let hawbNumberValue = invoiceBidInputs["hawbNumber"];
    hawbNumberValue = hawbNumberValue.trim();
    let hawbNumberFirstChar = hawbNumberValue.charAt(0);
    let hawbNumberLastChar = hawbNumberValue.charAt(hawbNumberValue.length - 1);
    let alphaNumericPattern = /^[a-z0-9]+$/i;
    // let firstCharResult = hawbNumberFirstChar.match(alphaNumericPattern);
    let hawbNumberMatch = hawbNumberValue.match(alphaNumericPattern);
    if (hawbNumberMatch == null || hawbNumberMatch === "") {
      error.message =
        "HAWB Number should contain only alpha numeric characters";
      error.isError = true;
      return error;
    }

    // let lastCharResult = hawbNumberLastChar.match(alphaNumericPattern);
    // if (lastCharResult == null || lastCharResult === "") {
    //   error.message =
    //     "HAWB Number should start and end with Numbers or Alphabets only";

    //   error.isError = true;
    //   return error;
    // }

    // let regexPattern = /^[a-z0-9#.-]+$/i;
    // let regexResult = hawbNumberValue.match(regexPattern);
    // if (regexResult == null || regexResult === "") {
    //   error.message =
    //     "HAWB Number can contain Numbers, Alphabets and Special Characters Hash(#) Hyphen(-) Dot(.) only";
    //   error.isError = true;
    //   return error;
    // }
  }

  if (invoiceBidInputs["proNumber"] === "") {
    error.message = "PRO Number is Mandatory";
    error.isError = true;
    return error;
  } else {
    // Validation For Invalid PRO Number Starts
    let proNumberValue = invoiceBidInputs["proNumber"];
    proNumberValue = proNumberValue.trim();
    let proNumberFirstChar = proNumberValue.charAt(0);
    let proNumberLastChar = proNumberValue.charAt(proNumberValue.length - 1);

    let alphaNumericPattern = /^[a-z0-9]+$/i;
    let firstCharResult = proNumberValue.match(alphaNumericPattern);
    if (firstCharResult == null || firstCharResult === "") {
      error.message = "PRO Number should contain only alpha numeric characters";
      error.isError = true;
      return error;
    }

    // let lastCharResult = proNumberLastChar.match(alphaNumericPattern);
    // if (lastCharResult == null || lastCharResult === "") {
    //   error.message =
    //     "PRO Number should start and end with Numbers or Alphabets only";
    //   error.isError = true;
    //   return error;
    // }

    // let regexPattern = /^[a-z0-9#.-]+$/i;
    // let regexResult = proNumberValue.match(regexPattern);
    // if (regexResult == null || regexResult === "") {
    //   error.message =
    //     "PRO Number can contain Numbers, Alphabets and Special Characters Hash(#) Hyphen(-) Dot(.) only";
    //   return error;
    // }
    // Validation For Invalid PRO Number Ends
  }

  if (childScacSelected["childScac"] === "Select SCAC") {
    error.message = "Child SCAC is Mandatory";
    error.isError = true;
    return error;
  }

  // Start and End Date Validation
  let dateFromFull = dayjs(invoiceBidInputs["actualShipmentPickupDate"]).format(
    "YYYYMMDD"
  );
  let dateToFull = dayjs(invoiceBidInputs["actualShipmentDeliveryDate"]).format(
    "YYYYMMDD"
  );

  let today = new Date();
  let todayFull = dayjs(today).format("YYYYMMDD");

  if (dateFromFull > todayFull) {
    error.message =
      "Actual Shipment Pickup Date cannot be greater than Current Date";
    error.isError = true;
    return error;
  }

  if (dateToFull < dateFromFull) {
    error.message =
      "Actual Shipment Delivery Date cannot be lesser than Actual Shipment Pickup Date";
    error.isError = true;
    return error;
  }

  return error;
}

export function validateBidFieldInputs(currencySelected) {
  const error = {
    message: "",
    isError: false,
  };
  if (currencySelected["currCode"] === "Select Currency") {
    error.message = "Currency is Mandatory";
    error.isError = true;
    return;
  }

  return error;
}

export const invoiceBidTableInputValidation = async (
  status,
  rowData,
  currentComponent,
  weightThreshold
) => {
  const error = {
    message: "",
    isError: false,
  };

  if (typeof rowData.feeCode === "undefined" || !rowData.feeCode) {
    error.isError = true;
    error.message = "Fee Code is mandatory";
    return error;
  }

  if (typeof rowData.contractedYN === "undefined" || !rowData.contractedYN) {
    error.isError = true;
    error.message = "Contracted is mandatory";
    return error;
  }

  if (typeof rowData.tariffType === "undefined" || !rowData.tariffType) {
    error.isError = true;
    error.message = "Tariff Type is mandatory";
    return error;
  }

  if (typeof rowData.quantity === "undefined" || !rowData.quantity) {
    error.isError = true;
    error.message = "Quantity is mandatory";
    return error;
  } else if (parseFloat(rowData.quantity) <= 0) {
    error.isError = true;
    error.message = "Quantity should be greater than 0";
    return error;
  } else if (currentComponent === "invoice") {
    //check if that is bid line item or invoice line item for status 73.
    if (status.current == 73) {
      if (rowData.sendBack == "Y") {
        let isValidChange = await percentageChecker(
          parseFloat(rowData.oldQuantity),
          parseFloat(rowData.quantity),
          weightThreshold
        );
        if (!isValidChange) {
          error.isError = true;
          error.message =
            "% of Quantity change cannot exceed the threshold value: 10";
          return error;
        }
      }
    } else {
      let isValidChange = await percentageChecker(
        parseFloat(rowData.oldQuantity),
        parseFloat(rowData.quantity),
        weightThreshold
      );
      if (!isValidChange) {
        error.isError = true;
        error.message =
          "% of Quantity change cannot exceed the threshold value: 10";
        return error;
      }
    }
  }

  if (typeof rowData.chargePerUnit === "undefined" || !rowData.chargePerUnit) {
    error.isError = true;
    error.message = "Charge Per Unit is mandatory";
    return error;
  } else if (parseFloat(rowData.chargePerUnit) <= 0) {
    error.isError = true;
    error.message = "Charge Per Unit should be greater than 0";
    return error;
  }

  return error;
};
